import type { PerformanceMetric } from '@/context/performance';
import { usePerformance } from '@/context/performance';
import { useMountEffect } from '@/hooks/use-mount-effect';

export function RecordPerformanceMetric(props: { performanceMetric: PerformanceMetric }) {
  const recordPerformanceMetric = usePerformance();

  useMountEffect(() => {
    recordPerformanceMetric(props.performanceMetric);
  });

  return null;
}
